import { showNotification } from '@publicisgroupe/p-os-components';
import { useCallback, useEffect } from 'react';
import { POS_NOTIFICATION } from 'utils/constants';
import { NotificationTypes } from 'utils/enums';

export const PosNotificationsHandler = () => {
  const displayNotification = (notificationData: any) => {
    switch (notificationData.type) {
      case NotificationTypes.Success: {
        showNotification.success(notificationData);
        break;
      }
      case NotificationTypes.Info: {
        showNotification.info(notificationData);
        break;
      }
      case NotificationTypes.Warning: {
        showNotification.warning(notificationData);
        break;
      }
      case NotificationTypes.Error: {
        showNotification.error(notificationData);
        break;
      }
      default:
        break;
    }
  };

  const handlePosNotifications = useCallback((event: MessageEvent<any>) => {
    if (event.data.message === POS_NOTIFICATION) {
      const notificationData = event.data.notification;
      if (notificationData) displayNotification(notificationData);
    }
  }, []);

  useEffect(() => {
    window.addEventListener('message', handlePosNotifications, false);
    return () => {
      window.removeEventListener('message', handlePosNotifications);
    };
  }, [handlePosNotifications]);

  return <></>;
};
